jQuery(document).ready(function($) {
  const className = "presentation-active";

  $(".presentation_method_select").on("change", function() {
    // hide the active presentation method
    $(`.${className}`).animate({ opacity: 0 }, null, () => {
      $(`.${className}`).removeClass(className);

      console.log(`.o-${this.value}`);
      $(`.o-${this.value}`).addClass(className);
      $(`.o-${this.value}`).animate({ opacity: 1 });
    });
  });
});
